/**
 * @author Fernando Ruano
 * @file index.js
 * @description Roles Container
 */

// Dependencies
import React from 'react';

// Components
import AppRoutes from '@nephro/components/AppRoutes';

// Routes
import routes from './routes';

/**
 * Roles Container.
 * @return { Node } React Roles container.
 */
const RolesContainer = () => {
  return (
    <div className="h-full">
      <AppRoutes routes={routes} />
    </div>
  );
};

/**
 * @name Roles.propTypes
 * @type { Object }
 */
RolesContainer.propTypes = {};

/**
 * Default props
 */
RolesContainer.defaultProps = {};

export default RolesContainer;
